/**
 * @license Copyright 2019 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
 */

.getting-started {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  min-height: 70vh;

  text-align: center;
}

.getting-started .paper {
  max-width: 50vw;
  padding: calc(var(--base-spacing) * 2);
}

.getting-started pre {
  display: inline;
}

.getting-started img {
  height: 80px;
  width: 80px;
  margin-bottom: calc(var(--base-spacing) * 2);
}
